(() => {
  'use strict';

  let modal = null, overlay = null, currentData = null;

  function buildModal() {
    if (modal) return;

    overlay = document.createElement('div');
    overlay.className = 'amotea-qo-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeModal);

    modal = document.createElement('div');
    modal.className = 'amotea-qo-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick options');
    modal.innerHTML = `
      <button class="amotea-qo-close" aria-label="Close" type="button">&#215;</button>
      <div class="amotea-qo-body">
        <div class="amotea-qo-image-col">
          <img class="amotea-qo-image" src="" alt="" width="400" height="500" loading="lazy">
        </div>
        <div class="amotea-qo-detail-col">
          <p  class="amotea-qo-vendor"></p>
          <h2 class="amotea-qo-title"></h2>
          <p  class="amotea-qo-price"></p>
          <div class="amotea-qo-options"></div>
          <div class="amotea-qo-qty-row">
            <button class="amotea-qo-qty-btn amotea-qo-qty-minus" type="button" aria-label="Decrease">−</button>
            <input  class="amotea-qo-qty-input" type="number" value="1" min="1" max="99" aria-label="Quantity">
            <button class="amotea-qo-qty-btn amotea-qo-qty-plus"  type="button" aria-label="Increase">+</button>
          </div>
          <button class="amotea-qo-add" type="button">Add to bag</button>
          <a class="amotea-qo-full-link" href="#">View full details →</a>
          <p class="amotea-qo-desc"></p>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    modal.querySelector('.amotea-qo-close').addEventListener('click', closeModal);

    const qtyInput = modal.querySelector('.amotea-qo-qty-input');
    modal.querySelector('.amotea-qo-qty-minus').addEventListener('click', () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
    });
    modal.querySelector('.amotea-qo-qty-plus').addEventListener('click', () => {
      qtyInput.value = Math.min(99, parseInt(qtyInput.value) + 1);
    });

    modal.querySelector('.amotea-qo-add').addEventListener('click', handleAddToBag);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('amotea-qo-modal--open')) closeModal();
    });
  }

  function openModal(product) {
    buildModal();
    currentData = product;

    const firstVariant  = product.variants[0];
    const featuredImage = product.featured_image;

    const imgEl = modal.querySelector('.amotea-qo-image');
    if (featuredImage) {
      imgEl.src = featuredImage.replace(/(\.\w+)$/, '_600x750$1');
      imgEl.alt = product.title;
    }

    modal.querySelector('.amotea-qo-vendor').textContent   = product.vendor || '';
    modal.querySelector('.amotea-qo-title').textContent    = product.title;
    modal.querySelector('.amotea-qo-full-link').href       = product.url;

    const available = product.variants.find(v => v.available) || firstVariant;
    updatePrice(available);

    const rawDesc = (product.description || '').replace(/<[^>]+>/g, '').trim();
    modal.querySelector('.amotea-qo-desc').textContent =
      rawDesc.length > 160 ? rawDesc.slice(0, 160).trimEnd() + '…' : rawDesc;

    buildOptions(product);
    modal.querySelector('.amotea-qo-qty-input').value = 1;

    overlay.classList.add('amotea-qo-overlay--open');
    modal.classList.add('amotea-qo-modal--open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => modal.querySelector('.amotea-qo-close').focus(), 50);
  }

  function closeModal() {
    if (!modal) return;
    overlay.classList.remove('amotea-qo-overlay--open');
    modal.classList.remove('amotea-qo-modal--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentData = null;
  }

  function buildOptions(product) {
    const container = modal.querySelector('.amotea-qo-options');
    container.innerHTML = '';
    if (!product.options_with_values || product.variants.length <= 1) return;

    product.options_with_values.forEach((opt, optIndex) => {
      const isColor = /colou?r|colore/i.test(opt.name);
      const group   = document.createElement('div');
      group.className = 'amotea-qo-option-group';

      const label = document.createElement('div');
      label.className = 'amotea-qo-option-label';
      label.textContent = opt.name;
      group.appendChild(label);

      const btns = document.createElement('div');
      btns.className = isColor ? 'amotea-qo-option-swatches' : 'amotea-qo-option-sizes';

      opt.values.forEach((val, valIndex) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.option = optIndex;
        btn.dataset.value  = val;
        btn.setAttribute('aria-label', val);

        if (isColor) {
          btn.className = 'amotea-qo-swatch';
          btn.style.backgroundColor = val.toLowerCase().replace(/\s+/g, '');
          btn.title = val;
        } else {
          btn.className   = 'amotea-qo-size-btn';
          btn.textContent = val;
        }

        if (valIndex === 0) btn.classList.add('is-active');

        btn.addEventListener('click', () => {
          btns.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          updateSelectedVariant(product);
        });

        btns.appendChild(btn);
      });

      group.appendChild(btns);
      container.appendChild(group);
    });
  }

  function updateSelectedVariant(product) {
    const selected = {};
    modal.querySelectorAll('.amotea-qo-options button.is-active').forEach(btn => {
      selected[parseInt(btn.dataset.option)] = btn.dataset.value;
    });
    const variant = product.variants.find(v =>
      Object.entries(selected).every(([i, val]) => v.options[parseInt(i)] === val)
    );
    if (variant) updatePrice(variant);
  }

  function updatePrice(variant) {
    if (!variant) return;
    const priceEl = modal.querySelector('.amotea-qo-price');

    if (window.Shopify && window.Shopify.formatMoney) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          `<span class="amotea-qo-price-sale">${Shopify.formatMoney(variant.price)}</span>` +
          `<s class="amotea-qo-price-compare">${Shopify.formatMoney(variant.compare_at_price)}</s>`;
      } else {
        priceEl.textContent = Shopify.formatMoney(variant.price);
      }
    }

    const addBtn = modal.querySelector('.amotea-qo-add');
    addBtn.disabled = !variant.available;
    addBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    addBtn.dataset.variantId = variant.id;
    addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
  }

  async function handleAddToBag() {
    const addBtn    = modal.querySelector('.amotea-qo-add');
    const qtyInput  = modal.querySelector('.amotea-qo-qty-input');
    const variantId = parseInt(addBtn.dataset.variantId);
    if (!variantId || addBtn.disabled) return;

    addBtn.disabled = true;
    const original  = addBtn.textContent;
    addBtn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: parseInt(qtyInput.value) || 1 })
      });
      if (!res.ok) throw new Error();

      addBtn.textContent = 'Added!';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(closeModal, 900);

    } catch (_) {
      addBtn.textContent = original;
      addBtn.disabled    = false;
    }
  }

  function initCards() {
    document.querySelectorAll('.product-block:not([data-qo-init])').forEach(card => {
      card.setAttribute('data-qo-init', '1');

      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const productUrl    = link.getAttribute('href');
      const hoverOverlay  = document.createElement('div');
      hoverOverlay.className = 'amotea-qo-card-overlay';

      const chooseBtn = document.createElement('button');
      chooseBtn.type      = 'button';
      chooseBtn.className = 'amotea-qo-choose-btn';
      chooseBtn.textContent = 'Choose options';

      hoverOverlay.appendChild(chooseBtn);

      const imageWrapper = card.querySelector('.product-block__image-link, .product-block__image');
      if (imageWrapper) {
        imageWrapper.style.position = 'relative';
        imageWrapper.appendChild(hoverOverlay);
      }

      chooseBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          const res     = await fetch(productUrl.split('?')[0] + '.js');
          if (!res.ok) throw new Error();
          const product = await res.json();
          openModal(product);
        } catch (_) {
          window.location.href = productUrl;
        }
      });
    });
  }

  function init() {
    initCards();
    document.addEventListener('shopify:section:load', initCards);
    document.addEventListener('collection:reloaded', initCards);

    if ('MutationObserver' in window) {
      const grid = document.querySelector('.product-list, .collection-grid, .product-grid');
      if (grid) new MutationObserver(initCards).observe(grid, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();